import type { ProductInformation, Sku } from '..';
import {
  allowanceDictionary,
  legacyPlanIdToV3Sku,
  productToBasicAllowanceSku,
} from '../constants/map-dictionary';
import type { LegacyPlanId } from '~/product-catalog/api/model';

/**
 * getter helper pure functions for operations that doesn't really need the whole product catalog
 */
export function getProductAndPlanFromSku(sku: Sku): Omit<ProductInformation, 'allowance'> {
  return allowanceDictionary[sku];
}

export function getBasicSkuFromChargeableSku(sku: Sku): Sku {
  const { product } = getProductAndPlanFromSku(sku);
  return productToBasicAllowanceSku[product.id];
}

export function getV3SkuFromPlanId(planId: LegacyPlanId): Sku {
  return legacyPlanIdToV3Sku[planId];
}

export function isLegacyPlanId(planId: string): planId is LegacyPlanId {
  return Object.keys(legacyPlanIdToV3Sku).includes(planId);
}
